do ($ = jQuery) ->
  $ ->
    ($ 'img[src$=".svg"]').each ->
      $img = $ this
      attributes = this.attributes
      $.get ($img.attr 'src'), (document) ->
        if ($svg = (($ document).find 'svg').removeAttr 'xmlns:a')?
          attributes.removeNamedItem 'src'
          attributes.removeNamedItem 'height' if attributes.height?.value == '0'
          attributes.removeNamedItem 'width' if attributes.width?.value == '0'
          $.each attributes, -> $svg.attr this.name, this.value
          ($svg.find 'title').remove()
          $img.replaceWith $svg